import {Directive, HostListener} from '@angular/core';

@Directive({
  selector: '[onlyAllowedCharacters]'
})
export class OnlyAllowedCharactersDirective {
  private allowedChars = /^[a-zA-Z0-9\-.]*$/;
  @HostListener( 'keypress', ['$event'] )
  onKeyPress(event: KeyboardEvent) {
    const inputChar = event.key;
    if(!this.allowedChars.test(inputChar))
    event.preventDefault();{

    }
  }

}
